import type { SVGProps } from 'react';

/** Figma `fatigue-normal.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const FatigueNormalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame" clipPath="url(#clip0_1320_2631)">
      <path
        id="Vector"
        d="M2 9C4 9 4 12 6 12C8 12 8 9 10 9C12 9 12 12 14 12C16 12 16 9 18 9C20 9 20 12 22 12C24 12 24 9 26 9"
        stroke="#058C80"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1320_2631">
        <rect width="22" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
